// The UI catalogs and how one is chosen. The UI speaks the participant's language when a
// catalog exists for it, English otherwise; Turkish before anyone has chosen (DEFAULT_LANGUAGE).

import { en } from './en';
import { tr, type Catalog, type MessageKey } from './tr';

export type { Catalog, MessageKey };

export const CATALOGS = { tr, en } satisfies Record<string, Catalog>;

export type UiLanguage = keyof typeof CATALOGS;

/** For a spoken language without its own catalog. */
export const FALLBACK_UI_LANGUAGE: UiLanguage = 'en';

export function uiLanguageFor(code: string): UiLanguage {
  return Object.hasOwn(CATALOGS, code) ? (code as UiLanguage) : FALLBACK_UI_LANGUAGE;
}

/** Fills "{name}" placeholders; an unknown placeholder stays as written. */
export function format(template: string, values: Readonly<Record<string, string | number>>): string {
  return template.replace(/\{(\w+)\}/g, (match, key: string) =>
    Object.hasOwn(values, key) ? String(values[key]) : match,
  );
}
